jQuery(function($) {

  window.ads = {}

  window.ads.observerCallback = (entries, observer) => {
    entries.forEach( entry => {
      if( entry.intersectionRatio >= 0.25 ) {
        let slot = entry.target.querySelector('ins')
        if( ! slot.classList.contains('adsbygoogle') && slot.dataset.adsbygoogleStatus != 'done' ) {
          slot.classList.add('adsbygoogle');
          (adsbygoogle = window.adsbygoogle || []).push({})
        }
      }
    })
  }

  window.ads.observe = function() {
    if ('IntersectionObserver' in window) {
      let ads = document.querySelectorAll('.lazy-loaded-ads')
      let object = new IntersectionObserver(
        window.ads.observerCallback, {
          rootMargin: '200px',
          threshold: 0.25
        }
      )
      for (const ad of ads) {
        object.observe(ad)
      }
    }
  }

  window.ads.observe()
})



// WEBPACK FOOTER //
// ./src/js/ads.js